const o=o=>Boolean(o&&o.getVelocity);export{o as isMotionValue};
